module.exports = __webpack_public_path__ + "img/memtop2.84a05aca.png";